module.exports = __webpack_public_path__ + "static/media/organisation-purple.e3e60306.svg";